import { render, staticRenderFns } from "./modalPedidosRecurrentes.vue?vue&type=template&id=058b2305&scoped=true&"
import script from "./modalPedidosRecurrentes.vue?vue&type=script&lang=js&"
export * from "./modalPedidosRecurrentes.vue?vue&type=script&lang=js&"
import style0 from "./modalPedidosRecurrentes.vue?vue&type=style&index=0&id=058b2305&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058b2305",
  null
  
)

export default component.exports